// extracted by mini-css-extract-plugin
export default {"traceViewerFrame":"TraceViewer-module__traceViewerFrame__YgaHf"};